module.exports = __webpack_public_path__ + "static/jay-90c0a88037e5c3734feb06de99808e65.svg";